export default "__VITE_ASSET__BK$7Z0bD__"